import { storeData } from '@user-center/utils/localService'
import { computed } from 'vue'
import { useMainStore } from '@/composables/store'

function safeParseStoreInformation() {
  if (!import.meta.client) {
    return null
  }

  const raw = window.localStorage.getItem(storeData.StoreInformation)
  if (!raw) {
    return null
  }

  try {
    return JSON.parse(raw)
  }
  catch {
    return null
  }
}

export function resolveMallShopId(store?: any) {
  const localStorageShopId = import.meta.client
    ? (() => {
        try {
          return window.localStorage?.getItem('shopId') || ''
        }
        catch {
          return ''
        }
      })()
    : ''

  const localShopId = String(
    safeParseStoreInformation()?.id
    || localStorageShopId
    || '',
  ).trim()

  if (localShopId) {
    return localShopId
  }

  const storeInfoMap = store?.$state?.storeInfoDataMap
  if (storeInfoMap && typeof storeInfoMap === 'object') {
    const matchedStoreInfo = Object.values(storeInfoMap).find((item: any) => item?.id)
    return String((matchedStoreInfo as any)?.id || '').trim()
  }

  return ''
}

export function useMallShopId() {
  const store = useMainStore()

  const shopId = computed(() => resolveMallShopId(store))

  function getShopId() {
    return shopId.value
  }

  return {
    shopId,
    getShopId,
  }
}
